<template>
  <v-menu offset-y bottom left>
    <template v-slot:activator="{ on }">
      <v-btn
        v-on="on"
        elevation="0"
        fab
        small
        :color="$vuetify.breakpoint.mobile ? 'white' : 'transparent'"
      >
        <v-icon color="blue-grey darken-3">mdi-bell-outline</v-icon>
        <v-badge
          v-if="hasUnReadNotifications"
          dot
          overlap
          bordered
          right
          color="red"
        />
      </v-btn>
    </template>

    <div class="notifications-menu-card">
      <div class="ma-0 pa-4 d-flex justify-space-between align-center">
        <p
          class="blue-grey--text text--darken-1 text-subtitle-2 font-weight-bold"
        >
          {{ $t('notifications.notification_other') }}
        </p>
        <Button
          plain
          size="small"
          color="primary"
          to="/notifications"
          :text="$t('notifications.view_all')"
        />
      </div>
      <div class="pa-0 notifications-menu-content">
        <NotificationsListContainer
          :notifications="notifications"
          @showReportsDrawer="handleShowReportsDrawer"
        />
      </div>
      <div
        class="ma-0 pa-0 d-flex justify-end align-center pa-4"
        v-if="notifications.length > 0 && hasUnReadNotifications"
      >
        <Button
          plain
          size="small"
          color="primary"
          :text="$t('notifications.mark_all_as_read')"
          @click="readAll"
        />
      </div>
    </div>
  </v-menu>
</template>

<script>
import NotificationsListContainer from '@/components/Notifications/NotificationsListContainer.vue'
import Button from '@/components/UI/Button.vue'

import mixin from '@/mixins/mixin.vue'
import trackerMixin from '@/mixins/tracking/trackerMixin.vue'

import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'NotificationsMenu',

  components: {
    NotificationsListContainer,
    Button,
  },

  mixins: [mixin, trackerMixin],

  computed: {
    ...mapGetters(['notifications', 'hasUnReadNotifications']),
  },

  methods: {
    ...mapActions(['markAllNotificationsAsRead']),
    readAll() {
      return this.markAllNotificationsAsRead()
    },
    handleShowReportsDrawer(reportId) {
      this.$emit('showReportsDrawer', reportId)
      this.trackOpenReportList({ source: 'notificationIcon' })
    },
  },
}
</script>

<style lang="scss" scoped>
.notifications-menu-card {
  max-width: 500px;
  background-color: $color-white;
}

.notifications-menu-content {
  height: 60vh;
  overflow-y: scroll;
}
</style>
